export const LINK_TOKEN = "{link}";
